<template>
  <v-layout>
    <v-flex>
      <panel :title="$t('groupDetails.editGroup')">

        <v-text-field
          :label="$t('groupGenerics.groupName')"
          required
          :rules="[required]"
          v-model="group.group_name"
        ></v-text-field>

        <v-text-field
          :label="$t('groupGenerics.groupDesc')"
          required
          :rules="[required]"
          v-model="group.description"
        ></v-text-field>

        <div class="danger-alert" v-if="error">
          {{error}}
        </div>
        <v-layout class="modal-button-row">
        <v-btn
          dark
          block
          class="button-delete button-modal"
          @click="this.delete">
          {{$t('actions.delete')}}
        </v-btn>
        <v-btn
          dark
          block
          class="secondary button-modal"
          @click="save">
          {{$t('actions.saveModifications')}}
        </v-btn>
        </v-layout>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import GroupsApi from '@/api/groups-api'

export default {
  props: [
    'selectedId'
  ],
  data () {
    return {
      group: {
        groupID: null,
        group_name: null,
        description: null,
      },
      error: null,
      required: (value) => !!value || value === 0 || 'Required.',
    }
  },
  methods: {
    async save () {
      this.error = null
      try {
        await GroupsApi.put(this.group)
        this.$emit('close') // notify parent to close the modal
      } catch (err) {
        this.error = err.response.data.error.message
        console.log(err)
      }
    },
    async delete () {
      try {
        await GroupsApi.delete(this.group.group_id)
        this.$emit('close') // notify parent to close the modal
      } catch (err) {
        console.log(err)
        this.error = err.response.data.error.message
      }
    }
  },
  async mounted () {
    try {
      this.error = null
    } catch (err) {
      console.log(err)
      this.error = err.response.statusText
    }
  },
  watch: {
    selectedId: async function (val) {
      try {
        this.error = null
        const groupID = this.selectedId
        this.group = (await GroupsApi.show(groupID)).data
      } catch (err) {
        console.log(err)
        this.error = err.response.statusText
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/EditGroup.vue